<script>
  import { setContext, getContext, onMount, getAllContexts } from "svelte";
  import { user, language, contract, callout, Auth } from "./stores/index";
  import { UsersRepository } from "./repositories/index";
  import { LOCATION } from "svelte-routing";

  let config = getContext("config");

  const authClass = new Auth(user, "channel-manager");
  setContext("isAuthorized", authClass);

  let App = null;
  let instance = null;
  let target = null;

  const location = getContext(LOCATION);

  onMount(async () => {
    if (import.meta.env.MODE === "LOCAL_EVENT_MANAGER") {
      const module = await import("@gl/event-manager");
      App = module.default;
    } else {
      const etag = await fetch(
        `/event-manager-frontend/event-manager.es.js?timestamp=${Date.now()}`,
        {
          method: "HEAD",
        },
      )
        .then((res) => res.headers.get("etag"))
        .catch(() => null);
      const dynamicPath = `/event-manager-frontend/event-manager.es.js?etag=${etag}`;
      const module = await import(/* @vite-ignore */ dynamicPath);
      // App = module.default;

      instance = new module.default({
        target,
        props: {
          apiurl: config.API_URL,
          user: $user,
          isAuthorized: authClass,
          language: $language,
          contract: $contract,
          basepath: "/channel-manager",
          repositories: {
            getUsers: UsersRepository.getUsers.bind(this, $contract.id),
            getGroups: UsersRepository.getGroups.bind(this, $contract.id),
          },
          path: $location.pathname,
        },
      });
      instance.$on("callout", (e) => callout.set(e.detail.callout));
      return instance.$destroy;
    }
  });

  $: instance?.$set({ language: $language });
  $: instance?.$set({ user: $user });
  $: instance?.$set({ contract: $contract });
  $: instance?.$set({
    repositories: {
      getUsers: UsersRepository.getUsers.bind(this, $contract.id),
      getGroups: UsersRepository.getGroups.bind(this, $contract.id),
    },
  });
  $: instance?.$set({ path: $location.pathname });
</script>

{#if App}
  <svelte:component
    this={App}
    apiurl={config.API_URL}
    user={$user}
    isAuthorized={authClass}
    language={$language}
    contract={$contract}
    basepath="/channel-manager"
    repositories={{
      getUsers: UsersRepository.getUsers.bind(this, $contract.id),
      getGroups: UsersRepository.getGroups.bind(this, $contract.id),
    }}
    on:callout={(event) => callout.set(event.detail.callout)}
  />
{/if}

{#if import.meta.env.MODE !== "LOCAL_EVENT_MANAGER"}
  <div bind:this={target} id="event-manager" />
{/if}

<style>
  #event-manager {
    height: 100%;
    max-width: 100vw;
    overflow: auto;
  }
</style>
